<template>
  <section>
    <gs-header title="Quản lý ngân hàng">
      <router-link :to="{ name: 'create-bank' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="bankTable" :table-name="bankTable" data-source="banks" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <template slot-scope="datas">
          <el-table :data="datas.data" border style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[bankTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[bankTable].current_page - 1) * dataPaginations[bankTable].per_page)}}</small>
              </template>
            </el-table-column>

            <el-table-column label="Logo" width="150">
              <template slot-scope="scope">
                <p>
                  <img :src="scope.row.logo_path" width="100"
                    onerror="this.src='https://placeholdit.imgix.net/~text?txtsize=19&amp;txt=img&amp;w=150&amp;h=150'">
                </p>
              </template>
            </el-table-column>

            <el-table-column label="Tên">
              <template slot-scope="scope">
                <p v-if="scope.row.name">{{ scope.row.name }}</p>
              </template>
            </el-table-column>


            <el-table-column label="Tên rút gọn">
              <template slot-scope="scope">
                <p v-if="scope.row.short_name">{{ scope.row.short_name }}</p>
              </template>
            </el-table-column>

            <el-table-column label="Url">
              <template slot-scope="scope">
                <a :href="scope.row.url" v-if="scope.row.url">{{ scope.row.url }}</a>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-bank', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline">
                    <a @click.prevent="deleteBank(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
    </div>
  </section>
</template>

<script>
import ls from 'local-storage'
import { debounce } from 'lodash'
import { deleteBank } from 'src/api/bank'
export default {

  name: 'Bank',

  data() {
    return {
      filters: {
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      bankTable: 'banks'
    }
  },
  methods: {
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.bankTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.bankTable)
      }
    }, 300),
    removeFilter() {
      this.reloadGsTable(this.bankTable)
      this.filters = {
        sort: 'created_at:-1'
      }
    },
    deleteBank(bank) {
      this.$confirm(`Bạn chắc chắn muốn xóa ngân hàng ${bank.name}`, 'Xóa ngân hàng', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delCarrier(bank)
      }).catch(() => {

      })
    },
    delCarrier(bank) {
      deleteBank(bank.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa ngân hàng thành công'
          })
          this.reloadGsTable(this.bankTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Xóa ngân hàng thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.bankTable]) {
      this.filters = ls.get('filters')[this.bankTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.bankTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['banks']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Bank.vue?6440a2cc